import { FailureType } from './app-state.failure.type';
import { AppStateFailureItemWithErrorCode } from './app-state-errorcode.failure';

export class AppStateFailure {
  public failureType: FailureType;
  public failures: AppStateFailureItemWithErrorCode[];

  public constructor(
    type: FailureType,
    failures: AppStateFailureItemWithErrorCode[]
  ) {
    this.failureType = type;
    this.failures = failures;
  }
}
